/** @format */
import React, { FunctionComponent, ReactElement } from 'react';
import { TableCell, TableRow } from '@material-ui/core';
import { ComponentTypeParams, SimCardServiceItem, SimCardServiceTypeItem } from '../../../../../interfaces/collections/SimCardServiceInterface';
import { makeStyles } from '@material-ui/core/styles';
import adescomStyle from '../../../../../assets/jss/adescom/adescomStyle';
import { roles, UserRoleHelper } from '../../../../../helpers/UserRoleHelper';
import { DateHelper } from '../../../../../helpers/DateHelper';
import DeleteButton from '../../../../../components/Buttons/DeleteButton';
import TemplateButton from '../../../../../components/Buttons/TemplateButton';
import { Settings } from '@material-ui/icons';
import { FeatureVerbTypeMap } from '../../../../../modules/features/FeaturesTypes';
import { ServicesMvneType } from '../../../../../modules/lib/hooks/useOperatorType';
import { BmeParams } from './BmeParams';
import { SdgParams } from './SdgParams';
import { McBmeParams } from './McBmeParams';

const useStyle = makeStyles(adescomStyle);

type ActiveFeatureItemSdgBmeType = {
    simCardService: SimCardServiceItem;
    openComponentParamsDialog: (
        verbType: number,
        definitionComponent: SimCardServiceTypeItem,
        componentParamsDialogTitle: string,
        alreadySelectedValues: any
    ) => void;
};

export const ActiveFeatureItemSdgBme: FunctionComponent<ActiveFeatureItemSdgBmeType> = ({
    simCardService,
    openComponentParamsDialog,
}): ReactElement => {
    const classes = useStyle();

    const tableCellRoot = { root: classes.tableCellRoot };
    const allowOperation = UserRoleHelper.checkRole(roles.ROLE_BLOCK_OPERATION_ON_SERVICES_POST);

    let deleteParam: ComponentTypeParams | null = null;
    let modifyParam: ComponentTypeParams | null = null;

    if (simCardService.simCardServiceType.simCardServiceTypeParam) {
        for (let i = 0; i < simCardService.simCardServiceType.simCardServiceTypeParam.length; i++) {
            if (simCardService.simCardServiceType.simCardServiceTypeParam[i].verb === FeatureVerbTypeMap.DEACTIVATE) {
                deleteParam = simCardService.simCardServiceType.simCardServiceTypeParam[i];
            }
            if (simCardService.simCardServiceType.simCardServiceTypeParam[i].verb === FeatureVerbTypeMap.MODIFY) {
                modifyParam = simCardService.simCardServiceType.simCardServiceTypeParam[i];
            }
        }
    }

    const isHasModifyParams = (): boolean => modifyParam !== null;

    const isHasDeleteParams = (): boolean => deleteParam !== null;

    return (
        <React.Fragment>
            <TableRow hover={true}>
                <TableCell classes={tableCellRoot} padding="none" align="left">
                    {simCardService.simCardServiceType.mainname}
                </TableCell>
                <TableCell classes={tableCellRoot} padding="none" align="left">
                    {simCardService.simCardServiceType.description}
                </TableCell>
                <TableCell classes={tableCellRoot} padding="none" align="left">
                    {DateHelper.format(simCardService.activatedAt)}
                </TableCell>
                <TableCell classes={tableCellRoot} padding="none" align="right">
                    {simCardService.allowedOperation === 1 && simCardService.deletedAt === null && isHasDeleteParams() && allowOperation && (
                        <DeleteButton
                            disabled={!(simCardService.deletedAt === null)}
                            callback={(): void =>
                                openComponentParamsDialog(
                                    FeatureVerbTypeMap.DEACTIVATE,
                                    simCardService.simCardServiceType,
                                    'prov:feature.delete_feature',
                                    simCardService.servicesParams
                                )
                            }
                            callbackParam={{}}
                            tooltipTitle="prov:feature.delete_feature"
                        />
                    )}
                    {simCardService.allowedOperation === 1 && simCardService.deletedAt === null && isHasModifyParams() && allowOperation && (
                        <TemplateButton
                            tooltipTitle="prov:feature.modify_feature"
                            icon={Settings}
                            callback={(): void => {
                                openComponentParamsDialog(
                                    FeatureVerbTypeMap.MODIFY,
                                    simCardService.simCardServiceType,
                                    'prov:feature.modify_feature',
                                    simCardService.servicesParams
                                );
                            }}
                            callbackParam={{}}
                        />
                    )}
                </TableCell>
            </TableRow>
            {simCardService.simCardServiceType.serviceType === ServicesMvneType.BME && <BmeParams simCardService={simCardService} />}
            {simCardService.simCardServiceType.serviceType === ServicesMvneType.MCBME && <McBmeParams simCardService={simCardService} />}
            {simCardService.simCardServiceType.serviceType === ServicesMvneType.SDG && <SdgParams simCardService={simCardService} />}
        </React.Fragment>
    );
};
